<div class="acquisition-form">
  <div class="acquisition-form__header">
    <h3 class="acquisition-form__title">{{ 'title.acquisition' | translate | uppercase }}</h3>
  </div>

  <div class="acquisition-form__field">
    <label class="acquisition-form__field-label">
      {{ 'core.assettype' | translate | uppercase }}
    </label>
    <ts-searchable-single-selector
      [loaded]="assetTypesLoaded"
      [options]="assetTypeOptions"
      [selected]="selectedAssetType"
      [searchTerm]="assetTypeSearchTerm"
      [errorKey]="assetTypeErrorKey"
      dataCy="asset-type-selector"
      (selectedChange)="assetTypeSelected.emit($event)"
      (searchTermChanged)="assetTypeSearchChanged.emit($event)"
      (lastItemReached)="assetTypeLastItemReached.emit()"
    ></ts-searchable-single-selector>
  </div>

  <!-- Predefined sample names — collapses to the top when manual mode turns on. -->
  <div *ngIf="!manualConfigMode" @collapse class="acquisition-form__field" data-cy="sample-names-field">
    <label class="acquisition-form__field-label">
      {{ 'method_type_editor.label.predefined_sample_names' | translate | uppercase }}
    </label>
    <ts-localized-chips-input
      [chips]="sampleNames"
      [currentLanguage]="currentLanguage"
      [placeholderKey]="'help.default_sample_names'"
      (chipAdded)="sampleNameAdded.emit($event)"
      (chipRemoved)="sampleNameRemoved.emit($event)"
      (chipUpdated)="sampleNameUpdated.emit($event)"
    ></ts-localized-chips-input>

    <button
      type="button"
      class="acquisition-form__manual-config"
      data-cy="method-type-manual-config"
      (click)="manualConfigRequested.emit()"
    >
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      {{ 'method_type_editor.button.manual_config' | translate }}
    </button>
  </div>

  <!-- Manual config — expands from the bottom in place of the sample names. -->
  <div *ngIf="manualConfigMode" @collapse class="acquisition-form__config" data-cy="method-type-config-panel">
    <h3 class="acquisition-form__title">
      {{ 'method_type_editor.manual_config.section.title' | translate | uppercase }}
    </h3>
    <p class="acquisition-form__config-warning">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ 'method_type_editor.manual_config.section.description' | translate }}</span>
    </p>
    <ts-json-editor
      [value]="methodTypeConfig"
      [showHeaderActions]="false"
      (parseStateChange)="configChanged.emit($event)"
    ></ts-json-editor>
    <div class="acquisition-form__config-error" *ngIf="configErrorKey" data-cy="method-type-config-error">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ configErrorKey | translate }}</span>
    </div>

    <!-- Tooltip on the wrapper span: matTooltip does not fire on the disabled button. -->
    <span
      class="acquisition-form__manual-config-exit"
      [matTooltip]="'method_type_editor.manual_config.exit.tooltip' | translate"
      [matTooltipDisabled]="canExitManualConfig"
      [matTooltipShowDelay]="350"
    >
      <button
        type="button"
        class="acquisition-form__manual-config"
        data-cy="method-type-exit-manual-config"
        [disabled]="!canExitManualConfig"
        (click)="manualConfigExitRequested.emit()"
      >
        <i class="ri-arrow-go-back-line" aria-hidden="true"></i>
        {{ 'method_type_editor.manual_config.exit.button' | translate }}
      </button>
    </span>
  </div>
</div>
